// Роуты витрины дизайн-системы — children для монтирования проектом.
// offerstream (router/index.js):
//   { path: 'design-system', meta: {…чистый холст…},
//     component: () => import('@martyrs/src/design-system/configurator/components/layouts/Configurator.vue'),
//     children: configuratorRoutes }
// meta наследуется детьми из родителя (vue-router мержит matched-цепочку).

const configuratorRoutes = [
  { path: '', name: 'Design System', component: () => import('../components/pages/Introduction.vue') },

  // Основы
  { path: 'colors', name: 'DS Colors', component: () => import('../components/pages/Colors.vue') },
  { path: 'typography', name: 'DS Typography', component: () => import('../components/pages/Typography.vue') },
  { path: 'layout', name: 'DS Layout', component: () => import('../components/pages/LayoutSpacing.vue') },
  { path: 'utilities', name: 'DS Utilities', component: () => import('../components/pages/Utilities.vue') },

  // Кит CSS
  { path: 'states', name: 'DS States', component: () => import('../components/pages/States.vue') },
  { path: 'elements', name: 'DS Elements', component: () => import('../components/pages/Elements.vue') },
  { path: 'blocks', name: 'DS Blocks', component: () => import('../components/pages/Blocks.vue') },
  { path: 'sections', name: 'DS Sections', component: () => import('../components/pages/Sections.vue') },

  // Компоненты Vue
  { path: 'components/forms', name: 'DS Components Forms', component: () => import('../components/pages/ComponentsForms.vue') },
  { path: 'components/actions', name: 'DS Components Actions', component: () => import('../components/pages/ComponentsActions.vue') },
  { path: 'components/overlays', name: 'DS Components Overlays', component: () => import('../components/pages/ComponentsOverlays.vue') },
  { path: 'components/data', name: 'DS Components Data', component: () => import('../components/pages/ComponentsData.vue') },
  { path: 'components/media', name: 'DS Components Media', component: () => import('../components/pages/ComponentsMedia.vue') },
  { path: 'components/feedback', name: 'DS Components Feedback', component: () => import('../components/pages/ComponentsFeedback.vue') },

  // Ассеты
  { path: 'icons', name: 'DS Icons', component: () => import('../components/pages/Icons.vue') },
];

export default configuratorRoutes;
